import React from 'react';

import { Button, PlusCircleIcon } from '@metarouter-private/mr-mui';
import { isAllowedToWriteTags } from '@ion/api';

import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';
import MODAL_OPTIONS from 'app/settings/tags-page/MODAL_OPTIONS';

export default function AddTagButton() {
  const { onOpenModal } = usePipelineTagsTableContext();
  const canWrite = isAllowedToWriteTags();

  if (!canWrite) {
    return null;
  }

  return (
    <Button
      size="large"
      startIcon={<PlusCircleIcon />}
      onClick={() => onOpenModal(MODAL_OPTIONS.addTag)}
      data-test-id="addTagButton"
    >
      Add Tag
    </Button>
  );
}
